import React, { useState } from 'react';
import ListDeathCauses from './ListDeathCauses.js';
import AddDeathCause from './AddDeathCause.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const DeathCauses = ({ screen, setScreen, hideHeader }) => {
  const [localScreen, setLocalScreen] = useState("list");

  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  return (
    <>
      {!hideHeader && (
        <div className="content-header">
          <div className="action-buttons">
            <ListButton
              isActive={currentScreen === "list"}
              onClick={() => setCurrentScreen("list")}
            />
            <AddButton
              isActive={currentScreen === "add"}
              onClick={() => setCurrentScreen("add")}
            />
          </div>
        </div>
      )}

      {(currentScreen === "list") && <ListDeathCauses />}
      {(currentScreen === "list") && <FAB onClick={() => setCurrentScreen("add")} />}
      {(currentScreen === "add") &&
        <AddDeathCause
          onSuccess={() => setCurrentScreen("list")}
        />
      }
    </>
  );
}

export const DeathCausesActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
  </div>
);

export default DeathCauses;
